/**
 * DECISIONS 415 step 6b (ARCHITECTURE §5.52 (3)): what the commander reads of its side once a replan — `SideRead` — so its
 * planners share one read instead of each making its own. Lazy: a part is worked out on first ask and kept for the round.
 * Today the picture (core/picture.ts teamPicture: where the side believes the enemy is); the points as known, the squads'
 * strength and claims, and tickets and supply join it as the planners move onto it (step 6's later sub-steps, 408's supply).
 */
import type { GameState } from '../types';
import { teamPicture, type Belief } from '../core/picture';

export interface SideRead {
  /** The side's picture this round (read-only: shared by every planner). */
  picture(): readonly Belief[];
}

export function sideRead(state: GameState, team: number, tick: number): SideRead {
  let pic: Belief[] | null = null;
  return { picture: () => (pic ??= teamPicture(state, team, tick)) };
}
